import {
  NetworkEventData,
  RCEvent,
  EventName,
  EventType,
} from "../../core/eventhub/eventmodels.js";
import { EventController } from "../../core/eventhub/eventcontroller.js";
import { RidecellCallback } from "../../core/models/ridecellcallback.js";
import { CarsharingNetworkRequests } from "../networkrequestsbuilder.js";

export class SubscriptionsController {
  /**
   * Gets vehicle type leasing entities.
   *
   * @param {number} vehicle_type vehicle type ID.
   *
   * @returns {Object} response Response with the VehicleTypeLeasingEntities.
   */
  getVehicleTypeLeasingEntities(params) {
    return new Promise((resolve, reject) => {
      const queryParams = {
        ...params,
      };
      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.vehicleTypeLeasingEntities,
        queryParams
      );

      const getVehicleTypeLeasingEntitiesCallback = new RidecellCallback();
      getVehicleTypeLeasingEntitiesCallback.onSuccess = (response) => {
        resolve(response.results);
      };

      getVehicleTypeLeasingEntitiesCallback.onFailure = (error) => {
        reject(error);
      };
      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          requestData,
          getVehicleTypeLeasingEntitiesCallback
        )
      );
    });
  }

  /**
   * Gets vehicle type leasing entity details.
   *
   * @param {number} vehicle_type vehicle type ID.
   *
   * @returns {Object} response Response with the VehicleTypeLeasingEntityDetails.
   */

  getVTLEDetails({ id, ...queryParams }) {
    return new Promise((resolve, reject) => {
      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.vehicleTypeLeasingEntityDetails(id),
        queryParams
      );

      const getVTLEDetailsCallback = new RidecellCallback();
      getVTLEDetailsCallback.onSuccess = (response) => {
        resolve(response);
      };

      getVTLEDetailsCallback.onFailure = (error) => {
        reject(error);
      };
      this.sendEvent(
        new RCEvent(EventName.NETWORK, requestData, getVTLEDetailsCallback)
      );
    });
  }

  /**
     * Gets station vehicle types
     *
     * @param {number} station_id station ID.
     * @param {string} start_date_time Start Date time
     * @param {string} end_date_time End Date time

     *
     * @returns {Object} response Response with the StationVehicleTypes.
     */
  getStationVehicleTypes(params) {
    return new Promise((resolve, reject) => {
      const queryParams = {
        ...params,
      };
      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.stationAvailableVehicleTypes,
        queryParams
      );

      const getStationVehicleTypesCallback = new RidecellCallback();
      getStationVehicleTypesCallback.onSuccess = (response) => {
        resolve(response.results);
      };

      getStationVehicleTypesCallback.onFailure = (error) => {
        reject(error);
      };
      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          requestData,
          getStationVehicleTypesCallback
        )
      );
    });
  }

  /**
     * Gets specific vehicle type
     *
     * @param {number} station_id station ID.
     * @param {string} start_date_time Start Date time
     * @param {string} end_date_time End Date time

     *
     * @returns {Object} response Response with the StationVehicleTypes.
     */
  getVehicleType(id) {
    return new Promise((resolve, reject) => {
      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.vehicleTypes(id)
      );

      const getVehicleTypeCallback = new RidecellCallback();
      getVehicleTypeCallback.onSuccess = (response) => {
        resolve(response.results);
      };

      getVehicleTypeCallback.onFailure = (error) => {
        reject(error);
      };
      this.sendEvent(
        new RCEvent(EventName.NETWORK, requestData, getVehicleTypeCallback)
      );
    });
  }

  /**
   * Get active subscription
   */
  getSubscription(queryParams) {
    return new Promise((resolve, reject) => {
      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.getSubscription(),
        queryParams
      );

      const srCallback = new RidecellCallback();
      srCallback.onSuccess = (response) => {
        resolve(response);
      };
      srCallback.onFailure = (error) => {
        reject(error);
      };

      this.sendEvent(new RCEvent(EventName.NETWORK, requestData, srCallback));
    });
  }

  /**
   * Get subscription provider configuration
   */
  getSubscriptionProviderConfig(queryData) {
    return new Promise((resolve, reject) => {
      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.getSubscriptionProviderConfig(),
        queryData
      );

      const srCallback = new RidecellCallback();
      srCallback.onSuccess = (response) => {
        resolve(response);
      };
      srCallback.onFailure = (error) => {
        reject(error);
      };

      this.sendEvent(new RCEvent(EventName.NETWORK, requestData, srCallback));
    });
  }

  sendEvent(event) {
    EventController.addEvent(event);
  }
}
